import { render, staticRenderFns } from "./FormTextBox.vue?vue&type=template&id=22187b20&scoped=true"
import script from "./FormTextBox.vue?vue&type=script&lang=js"
export * from "./FormTextBox.vue?vue&type=script&lang=js"
import style0 from "./FormTextBox.vue?vue&type=style&index=0&id=22187b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22187b20",
  null
  
)

export default component.exports